import { useTooltipContext } from "./tooltip-provider";
import { TOOLTIPS } from "./tooltip-registry";

/**
 * Hook for accessing tooltip functionality.
 * Provides access to the active tooltip, dismiss function, and tooltip definitions.
 */
export function useTooltip() {
  const {
    activeTooltipId,
    dismissCounts,
    dismissTooltip,
    setProjectState,
    setCurrentToolbox,
    setOnDismissNavigate,
  } = useTooltipContext();

  const activeTooltip = activeTooltipId ? TOOLTIPS[activeTooltipId] : null;

  return {
    activeTooltipId,
    activeTooltip,
    dismissCounts,
    dismissTooltip,
    setProjectState,
    setCurrentToolbox,
    setOnDismissNavigate,
    tooltips: TOOLTIPS,
  };
}
